import { render, staticRenderFns } from "./TvaBodymovin.vue?vue&type=template&id=ef0bc828&"
import script from "./TvaBodymovin.vue?vue&type=script&lang=js&"
export * from "./TvaBodymovin.vue?vue&type=script&lang=js&"
import style0 from "./TvaBodymovin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports